import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useParams } from 'react-router-dom';
import AdminLayout from '@app/layout/AdminLayout.tsx';
import AiDispatcherRules from '@components/features/ai-dispatcher/AiDispatcherRules';

interface ComponentProps {}

/**
 * The same rule screen a company user gets, reached from a company's row in the admin company
 * list. The company comes from the route rather than from the logged-in user; everything else is
 * identical, and there are no global or shared rules.
 *
 * Gated on PERMISSION_ADMIN through AdminLayout — the AI-dispatcher permissions are for the
 * company side and are not required here.
 */
const AdminAiDispatcherPage: React.FC<ComponentProps> = () => {
  const { companyId } = useParams();

  if (!companyId) {
    return <></>;
  }

  return (
    <>
      <AdminLayout title={'AI dispatcher rules'}>
        <AiDispatcherRules companyId={companyId} />
      </AdminLayout>
    </>
  );
};

export default withAuthenticationRequired(AdminAiDispatcherPage);
